var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceRequestQuickServiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 20.2498C1.75 15.5837 4.75 13.75 8.25 13.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 20.2498H19.445C19.8918 20.2498 20.2844 19.9534 20.4068 19.5236L21.8873 14.3236C22.0691 13.685 21.5895 13.0498 20.9255 13.0498H13.6938C13.1353 13.0498 12.6445 13.4203 12.4916 13.9575L10.7 20.2498ZM10.7 20.2498H6.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11C10.683 11 12.25 9.433 12.25 7.5C12.25 5.567 10.683 4 8.75 4C6.817 4 5.25 5.567 5.25 7.5C5.25 9.433 6.817 11 8.75 11Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9847 2.4329C18.9568 2.18651 18.7485 2.00025 18.5005 2C18.2525 1.99975 18.0438 2.18557 18.0154 2.43191C17.838 3.96993 16.9699 4.83801 15.4319 5.01541C15.1856 5.04382 14.9997 5.25253 15 5.5005C15.0003 5.74847 15.1865 5.9568 15.4329 5.9847C16.9491 6.15645 17.8774 7.01617 18.0141 8.55536C18.0365 8.80725 18.2477 9.00028 18.5005 9C18.7534 8.99971 18.9642 8.80621 18.986 8.55426C19.1173 7.03683 20.0368 6.11734 21.5543 5.98599C21.8062 5.96418 21.9997 5.75344 22 5.50055C22.0003 5.24766 21.8073 5.03648 21.5554 5.01411C20.0162 4.87738 19.1564 3.94911 18.9847 2.4329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRequestQuickServiceIcon);
export default __webpack_public_path__ + "static/media/service-request-quick-service-icon.838c5687266c71af6ad43140f12b5367.svg";
export { ForwardRef as ReactComponent };